import React from "react";
import { connect } from "react-redux";
import "rc-slider/assets/index.css";
import {
  Input,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Col,
  Label,
  TabContent,
} from "reactstrap";
import Select from "react-select";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { validationTypes } from "../../../../../common/validationType";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { tempLangConverter } from "../../../../../helpers/lanugageHelper";
import CondtionTypeList from "../../../../areas/form/conditions/components/CondtionTypeList";
import { displayTypesField, sortTypes } from "../../../../models/displayTypes";
import { deepClone } from "../../../../../helpers/objectHelper";
import { ElementTabGroup } from "../../../../components/editor/tools/EditorTabGroup";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { renderElementSettings } from "../../../../helpers/renderElementSettings";



const optionStyle = {
  option: (styles, { data }) => {
    return {
      ...styles,
      fontSize: '12px',
      padding: "0 10px"
    };
  },
  container: styles => ({
    ...styles,
    minWidth: "100%"
  }),
  singleValue: (styles, { data }) => {
    return {
      ...styles,
      fontSize: '12px',
    };
  }
};

class FieldSettings extends React.Component {
  state = { activeTab: new Array(2).fill("1"), isChange: false };
  componentDidMount() {
    this.setState({
      activeTab: new Array(2).fill("1")
    });
  }
  handleSoftUpdate = element => {
    const { dispatch } = this.props;
    dispatch(formActions.updateFormElement(element));
  };
  handleSelectOnChange = (options, path) => {
    const names = path.split(".");
    const selectedElement = deepClone(this.props.selectedElement);
    if (names.length === 2) {
      selectedElement[names[0]][names[1]] = options.value;
    } else if (names.length === 3) {
      selectedElement[names[0]][names[1]][names[2]] = options.value;
    }

    this.handleSoftUpdate(selectedElement);
  };
  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray
    });
  };
  handleChange = (e, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = val !== null && val !== undefined ? val : e.target.value;

    if (e && e.target.value === "" && path === "props.length") {
      value = 0;
    }
    if (e && e.target.type === "checkbox") {
      value = e.target.checked;
    }
    if (path === 'data.titleWidth') {
      element.data.inputWidth = 100 - value;
    }
    if (path === 'data.inputWidth') {
      element.data.titleWidth = 100 - value;
    }

    if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
  }
  render() {
    const { selectedElement, selectedContainer } = this.props.form;
    return (
      selectedElement && (
        <React.Fragment>
          <div>
            <ElementTabGroup activeTab={this.state.activeTab[0]} toggle={this.toggle} />
            <TabContent
              className="editor-tabcontent"
              style={{ paddingBottom: '65px' }}
              activeTab={
                this.state.activeTab[0]
              }
            >
              {this.state.activeTab[0] === "1" && (
                <React.Fragment >
                  <ListExpansion
                    footer={false}
                    icon="fa fa-square"
                    defaultExpanded={true}
                    description="Content"
                  >

                    <div >
                      <Row
                        style={{
                          justifyContent: "center",
                          marginLeft: "2px",
                          width: "100%"
                        }}
                      >
                        <Col>
                          <Label>
                            <SystemLabel name="FieldTitle" />
                          </Label>
                          {selectedElement.props.labels.map((l, index) => {
                            return (
                              <React.Fragment key={index}>
                                <InputGroup className="mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <i
                                        className={`flag-icon flag-icon-${tempLangConverter(
                                          l.languageCode
                                        )}`}
                                      />
                                    </InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    type="text"
                                    value={selectedElement.props.labels[index].text}
                                    onChange={e =>
                                      this.handleChange(
                                        e,
                                        null,
                                        `props.labels.${index}.text`
                                      )
                                    }
                                  />
                                </InputGroup>
                              </React.Fragment>
                            );
                          })}
                        </Col>
                      </Row>
                      <hr />
                      <Row>
                        <Col
                          className="list-setting-item-title"
                          style={{ display: "inline-flex" }}
                        >
                          <Label>
                            <SystemLabel name="ShowSubInputX" />
                          </Label>

                        </Col>
                        <Col style={{ textAlign: "right", }}>
                          <JirangoSwitch
                            onChange={e => this.handleChange(e, null, `data.showSubInput`)}
                            isChecked={
                              selectedElement.data.showSubInput !== true
                                ? false
                                : true
                            }
                          />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col
                          className="list-setting-item-title"
                          style={{ display: "inline-flex" }}
                        >
                          <Label>
                            <SystemLabel name="ShowSubLabelX" />
                          </Label>

                        </Col>
                        <Col style={{ textAlign: "right", }}>
                          <JirangoSwitch
                            onChange={e => this.handleChange(e, null, `data.showSubLabel`)}
                            isChecked={
                              selectedElement.data.showSubLabel !== true
                                ? false
                                : true
                            }
                          />
                        </Col>
                      </Row>
                      <hr />
                      {selectedElement.data.displayType !== undefined && (
                        <Row>
                          <Col className="list-setting-item-title">
                            <Label>
                              <SystemLabel name="DisplayType" />
                            </Label>
                          </Col>
                          <Col className="list-setting-item-input">
                            <Select
                              classNamePrefix="jirango-select"
                              className="jirango-select"
                              options={displayTypesField.map(t => {
                                return { value: t.value, label: t.label };
                              })}
                              value={displayTypesField.find(t => {
                                return t.value === selectedElement.data.displayType;
                              })}
                              onChange={selectedOption =>
                                this.handleSelectOnChange(
                                  selectedOption,
                                  "data.displayType"
                                )
                              }
                            />
                          </Col>
                        </Row>
                      )}

                      {selectedElement.data.sortType !== undefined &&
                        selectedElement.data.displayType === "SELECT" && (
                          <React.Fragment>
                            <br />
                            <Row>
                              <Col className="list-setting-item-title">
                                <Label>
                                  <SystemLabel name="SortType" />
                                </Label>
                              </Col>
                              <Col className="list-setting-item-input">
                                <Select
                                  classNamePrefix="jirango-select"
                                  className="jirango-select"
                                  options={sortTypes.map(t => {
                                    return { value: t.value, label: t.label };
                                  })}
                                  value={sortTypes.find(t => {
                                    return t.value === selectedElement.data.sortType;
                                  })}
                                  style={optionStyle}
                                  onChange={selectedOption =>
                                    this.handleSelectOnChange(
                                      selectedOption,
                                      "data.sortType"
                                    )
                                  }
                                />
                              </Col>
                            </Row>
                          </React.Fragment>

                        )}
                      <hr />
                      <Row>
                        <Col className="list-setting-item-title">
                          <Label>
                            <SystemLabel name="MinLength" />
                          </Label>
                        </Col>
                        <Col className="list-setting-item-input">
                          <Input
                            autoComplete="jirango-nofill"
                            type="number"
                            onChange={e =>
                              this.handleChange(e, null, `props.length`)
                            }
                            value={selectedElement.props.length}
                          />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col className="list-setting-item-title">
                          <Label>
                            <SystemLabel name="MaxChars" />
                          </Label>
                        </Col>
                        <Col className="list-setting-item-input">
                          <Input
                            autoComplete="jirango-nofill"
                            type="number"
                            onChange={e =>
                              this.handleChange(e, null, `data.maxCharacters`)
                            }
                            value={selectedElement.data.maxCharacters}
                          />
                        </Col>
                      </Row>
                      <hr />
                      <Row>
                        <Col className="list-setting-item-title">
                          <Label>
                            <SystemLabel name="ValidationType" />
                          </Label>
                        </Col>
                        <Col className="list-setting-item-input">
                          <Select
                            classNamePrefix="jirango-select"
                            className="jirango-select"
                            options={validationTypes.map(t => {
                              return { value: t.value, label: t.label };
                            })}
                            value={validationTypes.find(t => {
                              return t.value === selectedElement.data.validation.type;
                            })}
                            style={optionStyle}
                            onChange={selectedOption =>
                              this.handleChange(null,
                                selectedOption.value,
                                "data.validation.type"
                              )
                            }
                          />
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col className="list-setting-item-title">
                          <Label>
                            <SystemLabel name="ValidationMessage" />
                          </Label>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="list-setting-item-title">
                          <Input
                            autoComplete="jirango-nofill"
                            type="textarea"
                            style={{ resize: "none", minHeight: '100px' }}
                            value={selectedElement.data.validation.message}
                            onChange={e =>
                              this.handleChange(e, null, `data.validation.message`)
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </ListExpansion>
                  <br />
                  {selectedContainer ?
                    <React.Fragment>
                      {renderElementSettings(
                        selectedContainer.type,
                        selectedContainer,
                        this.props.toggleConditionModal
                      )}
                      <Row>
                        <Col style={{
                          marginLeft: '22px',
                          marginTop: '5px',
                          fontStyle: 'italic'
                        }} className="list-setting-item-title">
                          <p
                            className="text-muted"
                            style={{ lineHeight: "initial",/*  marginTop: "5px" */ }}
                          >
                            <SystemLabel name="ElementIsInContainerInfo" />
                          </p>
                        </Col>
                      </Row>
                    </React.Fragment>

                    : null}
                </React.Fragment>
              )}

              {this.state.activeTab[0] === "2" && (
                <ListExpansion
                  footer={false}
                  icon="fa fa-square"
                  defaultExpanded={true}
                  description="FieldPlacements"
                >
                  <AlignmentButtonGroup
                    onChange={this.handleChange}
                    alignment={selectedElement.data.labelAlign}
                    path="data.labelAlign"
                    type={["left", 'center', 'right']}
                  />
                  <hr />
                  {selectedElement.data.padding !== undefined && (
                    <EditorSlider
                      value={selectedElement.data.padding}
                      defaultValue={0}
                      unitChange={() => null}
                      onChange={this.handleChange}
                      units={["px"]}
                      activeUnit={'px'}
                      steps={1}
                      max={100}
                      min={1}
                      path={'data.padding'}
                      label="Padding"
                    />
                  )}
                  {selectedElement.data.alignment !== 'center' ? <React.Fragment>
                    <hr />
                    {selectedElement.data.titleWidth !== undefined && (
                      <EditorSlider
                        value={selectedElement.data.titleWidth}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["%"]}
                        activeUnit={'%'}
                        steps={1}
                        max={100}
                        min={1}
                        path={'data.titleWidth'}
                        label="TitleColumnWidth"
                      />
                    )}
                    <hr />
                    {selectedElement.data.inputWidth !== undefined && (
                      <EditorSlider
                        value={selectedElement.data.inputWidth}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["%"]}
                        activeUnit={'%'}
                        steps={1}
                        max={100}
                        min={1}
                        path={'data.inputWidth'}
                        label="FieldColumnWidth"
                      />
                    )}
                  </React.Fragment> : null}
                  <hr />
                  <EditorSlider
                    value={selectedElement.data.style.width}
                    defaultValue={0}
                    unitChange={() => null}
                    onChange={this.handleChange}
                    units={["%"]}
                    activeUnit={'%'}
                    steps={1}
                    max={100}
                    min={1}
                    path={'data.style.width'}
                    label="InnerWidth"
                  />
                  <hr />
                </ListExpansion>
              )}
              {this.state.activeTab[0] === "3" && (
                <div >
                  <ListExpansion
                    footer={false}
                    icon="fa fa-square"
                    defaultExpanded={true}
                    description="RegistrationSettings"
                  >
                    <Row>
                      <Col
                        className="list-setting-item-title"
                        style={{ display: "inline-flex" }}
                      >
                        <Label>
                          <SystemLabel name="ChangeLock" />
                        </Label>

                      </Col>
                      <Col style={{ textAlign: "right", }}>
                        <JirangoSwitch
                          onChange={e => this.handleChange(e, null, `data.changeLock`)}
                          isChecked={
                            selectedElement.data.changeLock !== true
                              ? false
                              : true
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="list-setting-item-title">
                        <p
                          className="text-muted"
                          style={{ lineHeight: "initial",/*  marginTop: "5px" */ }}
                        >
                          <SystemLabel name="ChangeLockInstruction" />
                        </p>
                      </Col>
                    </Row>
                  </ListExpansion >
                  <br />
                  <ListExpansion
                    footer={false}
                    icon="fa fa-square"
                    description="Conditions"
                  >
                    <CondtionTypeList
                      // onSelect={this.toggleConditionModal}
                      element={selectedElement}
                      toggleConditionModal={this.props.toggleConditionModal}
                    />
                  </ListExpansion>
                </div>

              )}
            </TabContent>
          </div>
        </React.Fragment >
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    selectedElement: state.form.selectedElement,
    selectedContainer: state.form.selectedContainer,
  };
}

export default connect(mapStateToProps)(FieldSettings);
